import { render, staticRenderFns } from "./mobile-dashboard.vue?vue&type=template&id=2f9ea4c8&"
import script from "./mobile-dashboard.vue?vue&type=script&lang=js&"
export * from "./mobile-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./mobile-dashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports